export default "__VITE_ASSET__cdefd7ae__"